<template>
  <div>
    <navbar></navbar>
    <div class="container is-fullheight hero-body">
        <div class="columns is-centered">
            <div class="column is-6">
				        <login-logo></login-logo>
                <h3 class="title has-text-centered has-text-dark">Customer Support</h3>
                <h2>We’re here to help and answer any question you might have. We look forward to hearing from you 🙂</h2>
                <div class="box">
                    <b-field label="E-Mail">
                        <b-input v-model="username" type="email" required="" placeholder="E-Mail">
                        </b-input>
                    </b-field>

                    <b-field label="Name">
                        <b-input v-model="name" type="text" placeholder="Name" required="" minlength="6" >
                        </b-input>
                    </b-field>
                    <b-field label="Reason for Contact">
                        <b-select  v-model="category"  placeholder="Select Category" required>
                            <option value="Tech">Tech Support</option>
                            <option value="Sales">Sales / Order Questions</option>
                            <option value="Product">Product Feedback</option>
                            <option value="Other">Other...</option>
                        </b-select>
                    </b-field>



                    <b-field>
                        <b-input type="textarea" v-model="description"
                            minlength="10"
                            maxlength="100"
                            placeholder="Describe your issue / question here">
                        </b-input>
                    </b-field>

                    <b-field>
                    <b-checkbox-button v-model="checkboxGroup"
                        native-value="person"
                        type="is-success">
                        <b-icon icon="check"></b-icon>
                        <span>I'm a person</span>
                    </b-checkbox-button>

                    <b-checkbox-button v-model="checkboxGroup"
                                native-value="robot"
                                type="is-danger">
                                <b-icon icon="close"></b-icon>
                                <span>I'm a robot</span>
                            </b-checkbox-button>

                        </b-field>
                        <p class="content">
                            <b>You identify as a </b>
                             {{ checkboxGroup }}
                        </p>

                    <button class="button is-dark is-large is-fullwidth" @click="doContact()">
                        Submit
                    </button>
                </div>
                <div class="has-text-centered">
                  <router-link to="/faq">Try our FAQs for immediate help!</router-link>
                </div>
                <div>

                <div class="block">
    <b-icon :type="{ 'is-success': isGreen }" icon="phone"></b-icon><span>518.882.9393 </span><br>
    <b-icon :type="{ 'is-success': isGreen }" icon="email"></b-icon><span>support@normsandratios.com</span>
      </div>

                </div>
            </div>
        </div>
    </div>
  </div>
</template>



<script>
import Navbar from "./features/Navbar"
import LoginLogo from "./features/LoginLogo"
import SampleReports from "./SampleReports"
import BuyReports from "./BuyReports"
import axios from "axios"

export default {
    name: 'Dashboard',
    data() {
        return {
			search: '',
                      checkboxGroup: [],
			desc: '',
            books: []
        }
    },
    components: {
        Navbar,
        SampleReports
    },
    mounted() {
        this.fetchBooks();
    },
    methods: {
        fetchBooks() {
        },
        doContact() {

        console.log(this.username)
        
    var URI = this.$api.REST_API + '/api/Ticket/Create' 
                    const options = {
      headers: {'X-Token': this.$store.getters.authToken}
    };
        axios
          .post(URI, {name: this.name, email: this.username, subject: this.category, body: this.description },options)
          .then(r => {
          console.log(r)


          })
          .catch(e => {
          })
        this.$router.push({ name: "Feedback" });

        },
        goSampleReports() {
        this.$router.push({ name: "SampleReports" });

        },
	},
}
</script>

<style scoped>
.top-10 {
    margin-top: 10px !important;
}
.grey-background {
    background-color: hsl(0, 0%, 86%) !important;
}

.hero.is-info {
  background: linear-gradient(
      rgba(0, 0, 0, 0.5),
      rgba(0, 0, 0, 0.5)
    ), url('../assets/images/hero/restaurant-hero.png') no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
}
.hero .nav, .hero.is-success .nav {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.hero .subtitle {
  padding: 3rem 0;
  line-height: 1.5;
}
</style>



// WEBPACK FOOTER //
// src/components/Contact.vue